import { BackendDynamicField, MultiselectAlarmOptions } from '../../../features/alarms/api/types';
import { convertDictionaryToList, getIndexFromList } from '../../../features/core/utils';
import { DynamicFieldValueType } from '../../../features/custom_frontend/models';


export const fieldIsMultiSelect = (field: BackendDynamicField) => {
    return field.field_type == 2 && field.options !== null;
 }

 export const fieldIsMultiCombobox = (field: BackendDynamicField) => {
    return field.field_type == 4 && field.options !== null;
 }


export const getBackendFieldsFormatted = (fields: BackendDynamicField): BackendDynamicField => {
    //este metodo es para formatear los campos base dinamicos que vienen del backend
    //para que sean compatibles con los componentes de frontend
    if(Object.keys(fields).length == 0) {
        return fields
    }

    try{

    //sort items by "order" key
    Object.keys(fields).sort((a, b) => {
        return fields[a]['order'] - fields[b]['order']
    }).reduce((obj, key) => {
        obj[key] = fields[key];
        return obj;
    }, {}) as BackendDynamicField;
    
    Object.keys(fields).forEach((key) => {
        if(fieldIsMultiSelect(fields[key]) || fieldIsMultiCombobox(fields[key])){
            if(fields[key]['options'] !== null){
                fields[key]['preselected_options'] = [];
                fields[key]['options'] = convertDictionaryToList(fields[key]['options'])
            }
        }
        fields[key]['current_value'] = fields[key]['value_type'] == 'boolean' ? false : null;
    })
    
    }catch(e){
        console.log("getBackendFieldsFormatted error", e)
    }

    return fields
}

export const updateBackendFieldsWithPatchData = (
    fieldsFromPatch: {
        [key: string]: string | number
    },
    frontendBaseFields: BackendDynamicField
): BackendDynamicField => {
    //este metodo es para actualizar los campos base dinamicos
    //con los campos de la respuesta del patch (ej: al editar un alarm o configurar un reporte)

    if(Object.keys(fieldsFromPatch).length == 0) {
        return frontendBaseFields
    }

      //recorro los campos de la respuesta del patch
      Object.keys(fieldsFromPatch).forEach((key:string) => {
        //checkeo que el campo exista en los campos base
        if(!frontendBaseFields.hasOwnProperty(key)){
            return
        }         
         let formField:BackendDynamicField = frontendBaseFields[key]; //campo base front
         let formFieldValue: any = fieldsFromPatch[key]; //valor de cada campo en la respuesta del patch

         if(fieldIsMultiSelect(formField)){
            //cargo el valor para el multiselect
            //busco el valor en la lista de opciones
            let multiSelectOptions = formField['options'] as MultiselectAlarmOptions[];
            if(multiSelectOptions){
               let optionIndex = getIndexFromList(multiSelectOptions, 'id', formFieldValue);
               if(optionIndex !== -1){
                    console.log("actualizo formFieldValue", formFieldValue);
                    formFieldValue = multiSelectOptions[optionIndex];
               }
            }
         }

         //si es un campo que no es combobox, solamente asigno el valor
         frontendBaseFields[key]['current_value'] = formFieldValue;

         //si es un combobox multiple asigno los valores
         if(fieldIsMultiCombobox(formField)){
            //comportamiento similar al multiselect
            let preselectedOptions = formFieldValue.map((item) => {
               return {
                  id: item['id'].toString(),
                  value: item['description']
               }
            })
            frontendBaseFields[key]['preselected_options'] = preselectedOptions;
            formFieldValue = preselectedOptions;
            frontendBaseFields[key]['current_value'] = null;
         }
      })
    return frontendBaseFields
}
       
